import { inject, Injectable } from '@angular/core';
// Services
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../services/http.service';
import { Observable } from 'rxjs';
import { ENV_TOKEN } from '../../../app-module.token';

@Injectable({
  providedIn: 'root'
})
export class ListaArchivosService {

  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;
  private httpService: HttpService = inject(HttpService);
  private httpClient: HttpClient = inject(HttpClient);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }


  /**
   * Obtiene un archivo por su ID, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agrega el ID del archivo a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param idDoc 
   * @param downloagOrg 
   * @returns 
   */
  getArchivo(idDoc: string, downloagOrg?: boolean): Observable<any> {
    const funcion = "icoij/download";
    const ruta = `${this.urlRaiz}/${funcion}/${idDoc}/${downloagOrg}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene un archivo para previsualización por su ID, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agrega el ID del archivo a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param idDoc 
   * @returns 
   */
  getArchivoPrevisualizacion(idDoc: string): Observable<any> {
    const funcion = "icoij/downloadpreview";
    const ruta = `${this.urlRaiz}/${funcion}/${idDoc}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene un acuerdo para previsualización por su nombre y extensión original, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan el nombre del archivo y la extensión original a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param file 
   * @param extOriginal 
   * @returns 
   */
  getAcuerdoPrevisualizacion(file: string, extOriginal?: number): Observable<any> {
    const funcion = "icoij/previewAcuerdoSISE";
    const ruta = `${this.urlRaiz}/${funcion}/${file}/${extOriginal}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene un archivo de acuerdo por su nombre y extensión original, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan el nombre del archivo y la extensión original a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param file 
   * @param extOriginal 
   * @returns 
   */
  getArchivoAcuerdo(file: string, extOriginal?: number): Observable<any> {
    const funcion = "icoij/downloadAcuerdoSISE";
    const ruta = `${this.urlRaiz}/${funcion}/${file}/${extOriginal}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene un archivo de acuerdo laboral por su nombre y extensión original, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan el nombre del archivo y la extensión original a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param file 
   * @param extOriginal 
   * @returns 
   */
  getArchivoAcuerdoLab(file: string, extOriginal?: number): Observable<any> {
    const funcion = "icoij/downloadAcuerdoLab";
    const ruta = `${this.urlRaiz}/${funcion}/${file}/${extOriginal}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Obtiene un acuerdo para previsualización por su nombre y extensión original, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan el nombre del archivo y la extensión original a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param file 
   * @param extOriginal 
   * @returns 
   */
  getAcuerdoPrevisualizacionLab(file: string, extOriginal?: number): Observable<any> {
    const funcion = "icoij/previewAcuerdoLab";
    const ruta = `${this.urlRaiz}/${funcion}/${file}/${extOriginal}`;
    return this.httpService.getRequest(ruta);
  }

}